import {
  START_UPLOAD,
  STEP_UPLOAD,
  FINISH_UPLOAD,
  ERROR_UPLOAD,
  RESET_UPLOAD,
} from './filesUploadProgress.actions';
import type { UploadProgressState } from './filesUploadProgress.model'

const initialState: UploadProgressState = { status: 'idle' };

export function filesUploadProgressReducer(
  state: UploadProgressState = initialState,
  action: any,
): UploadProgressState {
  switch (action.type) {
    case START_UPLOAD:
      return {
        status: 'running',
        current: 0,
        total: action.payload.total,
        percent: 0,
        failed: [],
      };

    case STEP_UPLOAD:
      return {
        status: 'running',
        current: action.payload.current,
        total: action.payload.total,
        currentFile: action.payload.currentFile,
        failed: action.payload.failed,
        percent: Math.round((action.payload.current / action.payload.total) * 100),
      };

    case FINISH_UPLOAD:
      if (state.status === 'running') {
        return { status: 'done', failed: state.failed };
      }
      return state;

    case ERROR_UPLOAD:
      if (state.status === 'running') {
        return { status: 'error', failed: state.failed };
      }
      return state;

    case RESET_UPLOAD:
      return { status: 'idle' };

    default:
      return state;
  }
}
